import $axios from "../api/accessor";
import { $api } from "../api/api";
import { getCookie } from "../utils/utils";

const token = getCookie("BscAdminToken");

export const CampaignsService = {
  async getAllCampaigns() {
    let response = await $axios.get($api("campaigns")).catch((err) => {
      return err.response;
    });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getCampaignById(id: number) {
    let { data, status } = await $axios
      .get($api("campaigns_id", { id }))
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },

  async addCampaign(payload: any) {
    try {
      const { data, status } = await $axios.post($api("campaigns"), payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
  async updateCampaign(payload: any) {
    try {
      const { data, status } = await $axios.put(
        $api("campaigns_id", { id: payload.id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },

  async deleteCompaing(id: string) {
    let { data, status } = await $axios
      .delete($api("campaigns_id", { id }), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .catch((err) => {
        return err.response;
      });
    return { data, status };
  },

  async addProductToCamaigns(id: number, payload: any) {
    try {
      const { data, status } = await $axios.post(
        $api("add_products_to_campaigns", { id }),
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return { data, status };
    } catch (err: any) {
      const errorMessage = err.response?.data?.message;
      return { data: null, status: err.response?.status, errorMessage };
    }
  },
};
